import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../mock";

const LanguageContext = createContext(null);

const getLanguageFromPath = () => {
  if (typeof window === "undefined") return "es";
  const segment = window.location.pathname.split("/").filter(Boolean)[0];
  return translations[segment] ? segment : "es";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getLanguageFromPath);

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
